// CUSTOM ICON COMPONENT
export const navigation = [

  {
    name: 'Earning',
    path: '/'
  },
  {
    name: 'Upgrade',
    path: '/'
  },
  {
    name: 'Tasks',
    path: '/'
  },
  {
    name: 'Metrics',
    path: '/'
  },
];